import { z } from 'zod';

export const analyticsRoleSchema = z.enum(['player', 'host', 'spectator', 'celebrity', 'system']);
export const analyticsFlowSchema = z.enum(['quickstart', 'prime', 'pavilion', 'beacon']);

export const analyticsBaseSchema = z.object({
  name: z.string().min(1).max(100),
  eventId: z.string().regex(/^[a-z][a-z0-9_]*$/).max(40),
  role: analyticsRoleSchema,
});

export type AnalyticsBase = z.infer<typeof analyticsBaseSchema>;

export const playerAnalyticsSchema = analyticsBaseSchema.extend({
  flow: analyticsFlowSchema.optional(),
  campaignId: z.string().optional(),
  sessionId: z.string().optional(),
  persistentId: z.string().optional(),
  playerAuthId: z.string().optional(),
});

export type PlayerAnalyticsEnvelope = z.infer<typeof playerAnalyticsSchema>;

/** @deprecated Use `playerAnalyticsSchema` for player events or `analyticsBaseSchema` for generic events */
export const analyticsEnvelopeSchema = playerAnalyticsSchema;
/** @deprecated Use `PlayerAnalyticsEnvelope` or `AnalyticsBase` */
export type AnalyticsEnvelope = PlayerAnalyticsEnvelope;
